import { FarmAreaId, FarmSlotId } from "State/Player/Farm/IFarmPlayerState";
import { createAction } from "Utility/Redux";
import { IRewardData } from "Utility/RewardHelper";
import { FarmItemId } from "System/Farm/Data/FarmItemData";
import { FarmCatalogueTab } from "System/UI/Menu/FarmCatalogueMenuHandler";

enum Types {
    SET_SLOT_ITEM_PREVIEW = 'setSlotItemPreview',
    CONFIRM_SLOT_ITEM = 'confirmSlotItem',
    CANCEL_SLOT_ITEM = 'cancelSlotItem',
    SET_CONSTRUCTION_MODE = 'setConstructionMode',
    PURCHASE_FARM_AREA = 'purchaseFarmArea',
    RECEIVE_MINI_GAME_REWARD = 'receiveMiniGameReward',
    CLEAR_FARM_AREAS = 'clearFarmAreas',
    CLEAR_VIEWED_ITEMS = 'clearViewedItems',
    SET_FARM_CATALOGUE_TAB = 'setFarmCatalogueTab'
}

export const FarmActions = {
    setSlotItemPreview: createAction(
        Types.SET_SLOT_ITEM_PREVIEW,
        resolve => (slotId: FarmSlotId, itemId: FarmItemId) => resolve({ slotId, itemId })
    ),
    confirmSlotItem: createAction(
        Types.CONFIRM_SLOT_ITEM,
        resolve => (slotId: FarmSlotId, itemId: FarmItemId) => resolve({ slotId, itemId })
    ),
    cancelSlotItem: createAction(
        Types.CANCEL_SLOT_ITEM,
        resolve => () => resolve()
    ),
    setConstructionMode: createAction(
        Types.SET_CONSTRUCTION_MODE,
        resolve => (enabled: boolean) => resolve(enabled)
    ),
    purchaseFarmArea: createAction(
        Types.PURCHASE_FARM_AREA,
        resolve => (areaId: FarmAreaId) => resolve(areaId)
    ),
    // TODO: Rename this action so it does not conflict with the Saga map minigame.
    receiveMiniGameReward: createAction(
        Types.RECEIVE_MINI_GAME_REWARD,
        resolve => (reward: IRewardData[]) => resolve(reward)
    ),
    clearFarmAreas: createAction(
        Types.CLEAR_FARM_AREAS,
        resolve => () => resolve()
    ),
    clearViewedItems: createAction(
        Types.CLEAR_VIEWED_ITEMS,
        resolve => (itemsId: FarmItemId[]) => resolve(itemsId)
    ),
    setFarmCatalogueTab: createAction(
      Types.SET_FARM_CATALOGUE_TAB,
      resolve => (tab: FarmCatalogueTab) => resolve(tab)
    ),
};
